<template lang="pug">
  .submit-buttons
    .row(v-if="submitVisible")
      .text-center.submit-btn
        button(type="submit" @click.prevent="submitMethod" :class="[{ disabled: submitDisabled }, submitClass]" data-mr-ass="submit").mr-btn.btn-fixed-width.font-xsmall.submit-btn {{ submitText }}
    .row(v-if="cancelVisible")
      .text-center
        button(type="button" @click.prevent="cancelMethod" :class="[{ disabled: cancelDisabled }, cancelTypeClass ]" data-mr-ass="cancel").cancel-btn {{ cancelButtonText }}

</template>

<script>
  export default {
    name: "SubmitButtons",
    props: {
      submitText: {
        type: String,
        required: true
      },

      submitMethod: {
        type: Function,
        required: false,
        default: function() { return }
      },

      submitDisabled: {
        type: Boolean,
        required: false,
        default: false
      },

      submitVisible: {
        type: Boolean,
        required: false,
        default: true
      },

      submitClass: {
        type: String,
        required: false,
        default: ''
      },

      cancelText: {
        type: String,
        required: false,
        default: 'Cancel'
      },

      cancelMethod: {
        type: Function,
        required: true
      },

      cancelDisabled: {
        type: Boolean,
        required: false,
        default: false
      },

      cancelVisible: {
        type: Boolean,
        required: false,
        default: true
      },

      cancelLink: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    computed: {
      cancelTypeClass() {
        return this.cancelLink ? 'btn-link color-mr-purple xs-f-small max-at-tweak' : 'mr-btn btn-tertiary btn-fixed-width font-xsmall';
      },

      cancelButtonText() {
        if (this.cancelLink) {
          return this.sentenceCase(this.cancelText);
        }

        return this.cancelText.toUpperCase();
      }
    },

    methods: {
      sentenceCase(text) {
        if (!text.length) {
          return;
        }

        return text.charAt(0).toUpperCase() + text.slice(1);
      }
    }
   }
</script>

<style scoped lang="stylus">
  .submit-btn
    margin-bottom 0.7em
    
</style>
